<template>
  <h1>Créer un nouveau compte</h1>
  <div class="inscription-page">
    <section class="form-container">
      <form @submit.prevent="handleInscription">
        <!-- Informations personnelles -->
        <h2>Informations personnelles</h2>
        <div class="form-group-grouped">
          <div class="form-group">
            <label for="civilite">Civilité <span class="required">*(Obligatoire)</span></label>
            <select id="civilite" v-model="civilite" required>
              <option value="">Sélectionnez</option>
              <option value="monsieur">Monsieur</option>
              <option value="madame">Madame</option>
            </select>
          </div>
          <div class="form-group">
            <label for="prenom">Prénom <span class="required">*</span></label>
            <input type="text" id="prenom" v-model="prenom" required />
          </div>
          <div class="form-group">
            <label for="nom">Nom <span class="required">*</span></label>
            <input type="text" id="nom" v-model="nom" required />
          </div>
            <div class="form-group">
            <label for="nom">Société</label>
            <input type="text" id="societe" v-model="societe" required />
          </div>
        </div>

        <!-- Informations d'adresse -->
        <h2>Informations d'adresse</h2>
        <div class="form-group">
          <label for="adresse">Adresse <span class="required">*</span></label>
          <input type="text" id="adresse" v-model="adresse" required />
        </div>
        <div class="form-group">
          <label for="codePostal">Code Postal <span class="required">*</span></label>
          <input type="text" id="codePostal" v-model="codePostal" required />
        </div>
        <div class="form-group">
          <label for="ville">Ville <span class="required">*</span></label>
          <input type="text" id="ville" v-model="ville" required />
        </div>
        <div class="form-group">
          <label for="pays">Pays <span class="required">*</span></label>
          <select id="pays" v-model="pays" required>
            <option value="">Sélectionnez un pays</option>
            <option v-for="country in countries" :key="country" :value="country">
              {{ country }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label for="telephone">Numéro de téléphone <span class="required">*</span></label>
          <input type="tel" id="telephone" v-model="telephone" required />
        </div>

        <!-- Informations de connexion -->
        <h2>Informations de connexion</h2>
        <div class="form-group">
          <label for="email">Email <span class="required">*</span></label>
          <input type="email" id="email" v-model="email" required />
        </div>
        <div class="form-group-grouped">
          <div class="form-group">
            <label for="password">Mot de passe <span class="required">*</span></label>
            <input type="password" id="password" v-model="password" required />
          </div>
          <div class="form-group">
            <label for="confirmPassword">Confirmez le mot de passe <span class="required">*</span></label>
            <input type="password" id="confirmPassword" v-model="confirmPassword" required />
          </div>
        </div>

        <!-- Bouton d'inscription -->
        <button type="submit" class="btn-inscription" :disabled="loading">
          {{ loading ? 'Création en cours...' : 'Créer un compte' }}
        </button>
        <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
      </form>
      <div class="login-link">
        <p>Vous avez déjà un compte ?</p>
        <router-link to="/connexion" class="btn-login">Se connecter</router-link>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "InscriptionPage",
  data() {
    return {
      civilite: "",
      prenom: "",
      nom: "",
      societe:"",
      adresse: "",
      codePostal: "",
      ville: "",
      pays: "",
      telephone: "",
      email: "",
      password: "",
      confirmPassword: "",
      loading: false,
      errorMessage: "",
      countries: [],
    };
  },
  methods: {
 async fetchCountries() {
  try {
    const res = await fetch(
      'https://restcountries.com/v3.1/all?fields=name,cca2,translations'
    );
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();

    this.countries = data
      .map(c => c?.translations?.fra?.common ?? c?.name?.common ?? '')
      .filter(Boolean)
      .sort((a, b) => a.localeCompare(b, 'fr', { sensitivity: 'base' }));
  } catch (e) {
    console.error('Erreur lors de la récupération des pays :', e);
  }
}
,
    async handleInscription() {
      if (!this.email || !this.password || !this.confirmPassword || !this.nom || !this.prenom || !this.pays || !this.telephone) {
        this.errorMessage = "Veuillez remplir tous les champs obligatoires.";
        return;
      }
      if (!/\S+@\S+\.\S+/.test(this.email)) {
        this.errorMessage = "Veuillez entrer un email valide.";
        return;
      }
      if (this.password.length < 8) {
        this.errorMessage = "Le mot de passe doit contenir au moins 8 caractères.";
        return;
      }
      if (this.password !== this.confirmPassword) {
        this.errorMessage = "Les mots de passe ne correspondent pas.";
        return;
      }
      this.loading = true;
      this.errorMessage = "";
      try {
        const response = await fetch("http://localhost:2028/loginn/register", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            civilite: this.civilite,
            prenom: this.prenom,
            nom: this.nom,
            societe: this.societe,
            adresse: this.adresse,
            codePostal: this.codePostal,
            ville: this.ville,
            pays: this.pays,
            telephone: this.telephone,
            email: this.email,
            password: this.password,
            role: "account", 
          }),
        });
        const data = await response.json();
        if (response.ok) {
             // Ensuite créer automatiquement son adresse dans la base
      await fetch("http://localhost:2028/api/addresses", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId: data._id,   // ID renvoyé par le register
          prefix: this.civilite,
          firstName: this.prenom,
          lastName: this.nom,
          company: this.societe,
          address: this.adresse,
          postalCode: this.codePostal,
          city: this.ville,
          country: this.pays,
          phoneNumber: this.telephone,
        }),
      });
          alert("Compte créé avec succès !");
          this.$router.push("/connexion");
        } else {
          this.errorMessage = data.message || "Erreur lors de la création du compte.";
        }
      } catch (error) {
        this.errorMessage = "Erreur lors de la création du compte. Veuillez réessayer.";
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.fetchCountries();
  },
};
</script>

<style scoped>
/*  ====== MODE CLAIR ====== */
.inscription-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  font-family: 'Poppins', sans-serif;
  background: linear-gradient(135deg, #e6f7f6, #f9f9f9);
  padding: 20px;
}

.form-container {
  background-color: #ffffff;
  padding: 40px;
  border-radius: 16px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 100%;
  max-width: 800px;
  transition: all 0.3s ease;
}

h1 {
  font-size: 1.9em;
  color: #00998b;
  margin-bottom: 15px;
}

h2 {
  font-size: 1em;
  color: #555;
  margin-bottom: 25px;
}

/* Formulaire */
.form-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}

label {
  font-weight: 600;
  color: #34495e;
  width: 160px;
  text-align: left;
  font-size: 0.85em;
}

input,
select {
  flex: 1;
  padding: 10px 12px;
  border: 1px solid #d1d3e2;
  border-radius: 6px;
  font-size: 0.9em;
  background-color: #fafafa;
  transition: 0.3s;
}

input:focus,
select:focus {
  border-color: #00998b;
  outline: none;
  box-shadow: 0 0 6px rgba(0, 153, 139, 0.3);
}

/* Bouton principal */
.btn-inscription {
  background: linear-gradient(135deg, #00998b, #007a6f);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1em;
  font-weight: 600;
  transition: all 0.3s ease;
  margin-top: 20px;
  width: 100%;
}

.btn-inscription:hover {
  background: linear-gradient(135deg, #007a6f, #00b0a0);
  transform: translateY(-2px);
}

.btn-inscription:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

/* Lien de connexion */
.login-link {
  margin-top: 20px;
  font-size: 0.9em;
  color: #555;
}

.btn-login {
  color: #00998b;
  font-weight: bold;
  text-decoration: none;
  transition: color 0.3s;
}

.btn-login:hover {
  color: #007a6f;
  text-decoration: underline;
}

/* Messages */
.error-message {
  color: #d9534f;
  margin-top: 10px;
  font-weight: 500;
}

.required {
  color: red;
  margin-left: 4px;
  font-weight: bold;
}

/* Responsive */
@media (max-width: 768px) {
  .form-container {
    padding: 30px;
    max-width: 100%;
  }
  .form-group {
    flex-direction: column;
    align-items: flex-start;
  }
  label {
    width: 100%;
    margin-bottom: 5px;
  }
  input,
  select {
    width: 100%;
  }
}

@media (max-width: 480px) {
  h1 {
    font-size: 1.6em;
  }
  h2 {
    font-size: 0.9em;
  }
  .form-container {
    padding: 25px;
  }
  .btn-inscription {
    font-size: 0.9em;
    padding: 10px;
  }
}

/* ====== MODE SOMBRE AUTOMATIQUE ====== */
@media (prefers-color-scheme: dark) {
  .inscription-page {
    background: #121212;
  }

  .form-container {
    background-color: #1e1e1e;
    box-shadow: 0 6px 18px rgba(255, 255, 255, 0.05);
  }

  h1 {
    color: #00d5c0;
  }

  h2 {
    color: #cccccc;
  }

  label {
    color: #cccccc;
  }

  input,
  select {
    background-color: #2a2a2a;
    border: 1px solid #444;
    color: #f5f5f5;
  }

  input::placeholder {
    color: #aaa;
  }

  input:focus,
  select:focus {
    border-color: #00d5c0;
    box-shadow: 0 0 5px rgba(0, 213, 192, 0.4);
  }

  .btn-inscription {
    background: linear-gradient(135deg, #00bfa6, #00897b);
  }

  .btn-inscription:hover {
    background: linear-gradient(135deg, #00998b, #00c8b0);
  }

  .login-link {
    color: #bbb;
  }

  .btn-login {
    color: #00c8b0;
  }

  .btn-login:hover {
    color: #40e0d0;
  }

  .error-message {
    color: #ff6b6b;
  }
}
</style>

